import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { openPdfInTab } from "./printUtils";

pdfMake.vfs = pdfFonts.vfs;

const SevaReceiptPrint_40Col = (values, logoBase64, poojaMasterList, nakshatraMasterList, gotraMasterList, targetWindow = null) => {
    return new Promise((resolve, reject) => {
        try {
            const paymentTypes = {
                'CA': 'Cash',
                'CQ': 'Cheque',
                'DC': 'Credit/Debit Card',
                'RT': 'RTGS',
                'UP': 'UPI',
                'NB': 'Net Banking',
                'WL': 'Wallet',
                'Online': 'Online',
            }

            const {
                receiptNo = "NA",
                receiptDate,
                poojaType1,
                poojaType2,
                poojaDateTime1,
                poojaDateTime2,
                devoteeName,
                mobile,
                alternateMobile,
                gotra,
                nakshatra,
                poojaAmount = 0,
                jaThaPraPersons = 0,
                jaThaPraRate = 0,
                extraRate = 0,
                extraPersons = 0,
                extraRemarks = "",
                paymentType,
                developmentCharges = 0,
            } = values || {};

            const formatDate = (dateObj) =>
                dateObj ? new Date(dateObj).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "";

            const formattedDate = receiptDate ? formatDate(receiptDate) : "NA";

            const gotraName = gotraMasterList.find((g) => g.gotraId?.toString() === gotra?.toString())?.gotraName || "NA";
            const nakshatraName = nakshatraMasterList.find((n) => n.nakshatraId?.toString() === nakshatra?.toString())?.nakshatraName || "NA";
            // const poojaTime = poojaMasterList.find((p) => p.poojaId?.toString() === poojaType1?.toString())?.poojaTime || "NA";

            // 🪔 Build pooja table
            const poojaDetails = [];
            const addPoojaIfValid = (type, dateTime) => {
                const item = poojaMasterList.find((p) => p.poojaId?.toString() === type?.toString());
                if (item) {
                    poojaDetails.push({
                        slNo: poojaDetails.length + 1,
                        poojaName: `${item.poojaName} - ${item.poojaTime}`,
                        date: formatDate(dateTime),
                        persons: item.noOfPersons,
                        rate: "",
                        amount: item.poojaAmount,
                    });
                }
            };

            addPoojaIfValid(poojaType1, poojaDateTime1);
            addPoojaIfValid(poojaType2, poojaDateTime2);

            if (jaThaPraPersons && jaThaPraRate) {
                poojaDetails.push({
                    slNo: poojaDetails.length + 1,
                    poojaName: "Additional Ja Tha Pra",
                    date: "",
                    persons: jaThaPraPersons,
                    rate: jaThaPraRate / jaThaPraPersons || 0,
                    amount: jaThaPraRate,
                });
            }

            if (extraRate || extraPersons) {
                poojaDetails.push({
                    slNo: poojaDetails.length + 1,
                    poojaName: "Extra Special Tha Pra",
                    date: "",
                    persons: extraPersons,
                    rate: "",
                    amount: extraRate + developmentCharges,
                });
            }

            const grandTotal = poojaDetails.reduce((sum, item) => sum + Number(item.amount || 0), 0);
            const totalPersons = poojaDetails.reduce((sum, item) => sum + Number(item.persons || 0), 0);

            // 🧾 Devotee info (aligned properly)
            const devoteeInfoTable = {
                table: {
                    widths: [60, "*"],
                    body: [
                        [{ text: "Devotee", bold: true, fontSize: 6 }, { text: devoteeName || "NA", fontSize: 6 }],
                        [{ text: "Mobile", bold: true, fontSize: 6 }, { text: mobile || "NA", fontSize: 6 }],
                        [{ text: "Gotra", bold: true, fontSize: 6 }, { text: gotraName, fontSize: 6 }],
                        [{ text: "Nakshatra", bold: true, fontSize: 6 }, { text: nakshatraName, fontSize: 6 }],
                        // [{ text: "Pooja Date", bold: true, fontSize: 6 }, { text: formatDate(poojaDateTime1), fontSize: 6 }],
                        // [{ text: "Pooja Time", bold: true, fontSize: 6 }, { text: poojaTime || "NA", fontSize: 6 }],
                    ],
                },
                layout: {
                    hLineWidth: () => 0,
                    vLineWidth: () => 0,
                    paddingLeft: () => 0,
                    paddingRight: () => 0,
                    paddingTop: () => 1,
                    paddingBottom: () => 1,
                },
                margin: [0, 2, 0, 5],
            };

            // 🪙 Pooja Table
            const poojaTable = {
                table: {
                    widths: [8, 52, 30, 10, 18, 20],
                    body: [
                        [
                            { text: "Sl", bold: true, fontSize: 6 },
                            { text: "Pooja", bold: true, fontSize: 6 },
                            { text: "Date", bold: true, fontSize: 6 },
                            { text: "No", bold: true, fontSize: 6 },
                            { text: "Rate", bold: true, fontSize: 6 },
                            { text: "Amt", bold: true, fontSize: 6 },
                        ],
                        ...poojaDetails.map((item) => [
                            { text: item.slNo, alignment: "center", fontSize: 5 },
                            { text: item.poojaName, fontSize: 5 },
                            { text: item.date, alignment: "center", fontSize: 5 },
                            { text: item.persons, alignment: "center", fontSize: 5 },
                            { text: item.rate ? `₹${item.rate}` : "", alignment: "right", fontSize: 5 },
                            { text: `₹${item.amount}`, alignment: "right", fontSize: 5 },
                        ]),
                        [
                            { text: "", colSpan: 4 }, {}, {}, {},
                            { text: "Total:", bold: true, alignment: "right", fontSize: 5 },
                            { text: `₹${grandTotal}`, bold: true, alignment: "right", fontSize: 5 },
                        ],
                    ],
                },
                layout: {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => "#999",
                    vLineColor: () => "#999",
                    paddingLeft: () => 2,
                    paddingRight: () => 2,
                    paddingTop: () => 1,
                    paddingBottom: () => 1,
                },
                margin: [0, 3, 0, 5],
            };

            // 🧾 Full Receipt Layout (optimized for 40-column printer)
            const docDefinition = {
                pageSize: { width: 180, height: "auto" }, // ~72mm wide
                pageMargins: [8, 8, 8, 8],
                content: [
                    {
                        image: "templeLogo",
                        width: 150,
                        alignment: "center",
                        margin: [0, 0, 0, 3],
                    },
                    {
                        stack: [
                            {
                                text: "Sri VENUGOPALA SWAMY TEMPLE (R)",
                                fontSize: 9,
                                bold: true,
                                alignment: "center",
                            },
                            {
                                text: "Sri Raghavendra Swamy Temple",
                                fontSize: 8,
                                bold: true,
                                alignment: "center",
                            },
                            {
                                text: "Old Airport Road, Near HAL Market, Vimanapura, Bangalore - 17",
                                fontSize: 5,
                                alignment: "center",
                                margin: [0, 1, 0, 1],
                            },
                            {
                                text: "Secretary: 9448512003  |  President: 9480809048",
                                fontSize: 5,
                                alignment: "center",
                                margin: [0, 0, 0, 5],
                            },
                        ],
                    },

                    { text: "----------------------------------------------------------------------------------------------", alignment: "center" },
                    {
                        columns: [
                            { text: `Receipt No: ${receiptNo}`, fontSize: 6 },
                            { text: `Date: ${formatDate(receiptDate)}`, fontSize: 6, alignment: "right" },
                        ],
                        margin: [0, 2, 0, 2],
                    },
                    { text: "----------------------------------------------------------------------------------------------", alignment: "center" },
                    devoteeInfoTable,
                    poojaTable,
                    {
                        columns: [
                            { text: `Payment: ${paymentTypes[paymentType] || paymentType || 'NA'}`, fontSize: 6 },
                            { text: `Total Persons: ${totalPersons}`, fontSize: 6, alignment: "right" },
                        ],
                        margin: [0, 2, 0, 5],
                    },
                    { text: "----------------------------------------------------------------------------------------------", alignment: "center" },
                    {
                        stack: [
                            { text: "Thank you for your contribution!", alignment: "center", fontSize: 5, margin: [0, 2, 0, 2] },
                            { text: "Office Contact: Srikanth: 9916077255 | Suresh: 9448357701", alignment: "center", fontSize: 6 },
                        ],
                    },
                ],
                images: { templeLogo: logoBase64 },
                defaultStyle: { fontSize: 6, lineHeight: 1.1 },
            };

            const pdfDoc = pdfMake.createPdf(docDefinition);
            openPdfInTab(pdfDoc, resolve, targetWindow);
        } catch (error) {
            console.error("Error in SevaReceiptPrint_40Col:", error);
            resolve({ success: false, error: error });
        }
    });
};

export default SevaReceiptPrint_40Col;
